module.exports = {
  bridges: '/bridges/api/v1/bridge/',
  call_lower_raised_hand: '/bridges/lower-hand/',
  call_toggle_status: '/bridges/api/v1/',
  call_boot: '/bridges/api/v1/boot/',
  call_nudge: '/bridges/api/v1/nudge/',
  call_lock: '/bridges/api/v1/lock-call/',
  add_person: '/bridges/api/v1/roundup-participant/',
  join_zoom_meeting: '/bridges/api/v1/roundup-participant-zoom/',
  bridges_send_sms: '/bridges/send_sms/',
  delete_did: '/bridges/api/v1/delete-did/',

  company: '/bridges/api/v1/company/',
  company_update: '/bridges/api/v1/company/update-company-info/',

  notifications: '/notifications/api/v1/notifications/',

  profile: '/accounts/api/v1/profile/?format=json',
  profile_get: '/accounts/api/v1/get-profile/',
  profile_update: '/accounts/api/v1/update-profile/',

  plans_change: '/accounts/api/v1/change-plan/',
  plans_getCurrent: '/accounts/api/v1/get-plan/',
  plans_cancel: '/accounts/api/v1/cancel-plan/',

  cards_remove: '/accounts/api/v1/delete-card/',
  cards_list: '/accounts/api/v1/list-cards/',
  cards_set: '/accounts/api/v1/set-card/',
  cards_set_default: '/accounts/api/v1/set-default-card/',

  login: '/accounts/api/v1/login',
  logout: '/accounts/api/v1/logout',
  signup: '/accounts/api/v1/signup',
  impersonate: '/accounts/api/v1/impersonation/',

  subusers: '/accounts/api/v1/get-subusers/',
  subusers_update: '/accounts/api/v1/update-subuser/',
  subusers_invite: '/accounts/api/v1/invite-subuser/',
  subusers_create: '/accounts/api/v1/create-subuser/',
  subusers_delete: '/accounts/api/v1/delete-subuser/',

  permissions: '/accounts/api/v1/get-permission/',

  password_forgot: '/accounts/api/v1/forgot-password',
  password_reset: '/accounts/api/v1/reset-password',
  password_change: '/accounts/api/v1/change-password',
};



/*****************
 ** WEBPACK FOOTER
 ** ./config/api-urls.js
 ** module id = 77
 ** module chunks = 0
 **/